import { useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";

import Logo from "./Logo";
import Wrapper from "../../StylesWrappers/General/header";
import NavIcon from "./NavIcon";
import { getUserDetails } from "../../utils/userStorage";
import { breakText } from "../../utils/breakText";
import { handleLogout } from "../../utils/logoutUser";
import { capitalize } from "../../utils/capitalize";

interface HeaderProps {
  dynamicDisplayOfHeaderTitle: string;
}

const Header = ({ dynamicDisplayOfHeaderTitle }: HeaderProps) => {
  const [userValue, setUserValue] = useState<string>("");
  const [isLogout, setIsLogout] = useState<boolean>(false);

  const navigate: NavigateFunction = useNavigate();

  useEffect(() => {
    const getUser = getUserDetails(); // Function to get the username from local storage and present it in the header
    setUserValue(getUser.username);
  }, []);

  // Logout a user
  const logoutUser = () => {
    handleLogout(setIsLogout, navigate);
  };

  return (
    <Wrapper>
      <div className="logo-and-icon">
        <Logo />
        <NavIcon />
      </div>
      <div className="header-text removeAtMobile">
        <p>{dynamicDisplayOfHeaderTitle}</p>
      </div>
      {userValue ? (
        <div className="profile">
          <h3 onClick={() => setIsLogout(!isLogout)}>
            <span>{breakText(userValue, userValue.length, 10)}</span>
            <span>{capitalize(userValue).charAt(0)}</span>
          </h3>
          {isLogout && <button onClick={logoutUser}>Logout</button>}
        </div>
      ) : (
        <Skeleton width={90} height={35} />
      )}
    </Wrapper>
  );
};

export default Header;
